import { render, staticRenderFns } from "./cell-renderer-aufgaben.vue?vue&type=template&id=7486fc4c"
import script from "./cell-renderer-aufgaben.vue?vue&type=script&lang=js"
export * from "./cell-renderer-aufgaben.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports